'use client';

import React from 'react';
import { Button } from '@/components/ui/button';
import { PhoneCall, MessageCircle, Mail } from 'lucide-react';

function telHref(phone) {
    if (!phone) return '';
    const clean = String(phone).replace(/[^\d+]/g, '');
    return `tel:${clean}`;
}

export default function ContactActionButtons({
    // show ONLY 2 at a time (any 2 of: 'chat' | 'call' | 'contact')
    show = ['chat', 'call'],
    classBtn1 = 'max-md:w-full',
    classBtn2 = 'max-md:w-full',
    // labels (customizable)
    chatLabel = 'Chat now',
    callLabel = 'Call now',
    contactLabel = 'Contact us',

    // shadcn button variants (customizable)
    chatVariant = 'default',
    callVariant = 'outline',
    contactVariant = 'secondary',

    // sizes
    size = 'default', // default | sm | lg | icon

    // actions
    onChat, // () => void
    phone, // "+1 555 123 4567"
    contactHref = '/contact',
    onContact, // optional () => void

    // icons (override if you want)
    chatIcon: ChatIcon = MessageCircle,
    callIcon: CallIcon = PhoneCall,
    contactIcon: ContactIcon = Mail,

    className = '',
}) {
    const visible = Array.isArray(show) ? show.slice(0, 2) : ['chat', 'call'];

    const Icon = ({ I }) => <I className="mr-2 size-6" aria-hidden="true" />;

    const actions = {
        chat: (
            <Button
                key="chat"
                type="button"
                variant={chatVariant}
                size={size}
                onClick={onChat}
                disabled={!onChat}
                className={classBtn1}
            >
                <Icon I={ChatIcon} />
                {chatLabel}
            </Button>
        ),

        call: (
            <Button
                key="call"
                asChild
                variant={callVariant}
                size={size}
                disabled={!phone}
                className={classBtn2}
            >
                <a
                    href={phone ? telHref(phone) : undefined}
                    aria-disabled={!phone}
                    className="text-white"
                >
                    <Icon I={CallIcon} />
                    {callLabel}
                </a>
            </Button>
        ),

        contact: onContact ? (
            <Button
                key="contact"
                type="button"
                variant={contactVariant}
                size={size}
                onClick={onContact}
            >
                <Icon I={ContactIcon} />
                {contactLabel}
            </Button>
        ) : (
            <Button key="contact" asChild variant={contactVariant} size={size}>
                <a href={contactHref}>
                    <Icon I={ContactIcon} />
                    {contactLabel}
                </a>
            </Button>
        ),
    };

    return (
        <div className={`flex flex-wrap gap-6 ${className}`}>
            {visible.map((k) => actions[k]).filter(Boolean)}
        </div>
    );
}
